import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3cbd32a2&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbd32a2"]])

export default __exports__